import {
  getAuthToken,
  getCurrentUser,
  isAuthTokenValid,
  userHasRoles
} from '@/lib/authentication'
import { requiresAuthentication } from '@/lib/routes'
import { defaultRoute, notAuthorizedRoute, loginRoute } from '@/lib/constants/routes'

const addAuthentication = (router) => {
  router.beforeEach((to, from, next) => {
    if (to.matched.some(requiresAuthentication)) {
      // Needs Authentication
      const authToken = getAuthToken()
      const currentUser = getCurrentUser()
      if (authToken == null || currentUser == null) {
        next({
          name: loginRoute.name,
          params: { nextUrl: to.fullPath }
        })
      } else {
        const allowedRoles = to.matched.flatMap(record => record.meta.roles)

        if (userHasRoles({ user: currentUser, allowedRoles })) {
          next()
        } else {
          next({ name: notAuthorizedRoute.name })
        }
      }
    } else {
      // Public
      if (isAuthTokenValid() && to.name === loginRoute.name) {
        next({ name: defaultRoute.name })
      } else {
        next()
      }
    }
  })

  return router
}

export default addAuthentication
